import React from 'react';
import { Heading } from '@uk-source-web/heading';
import { InfoCardsProps } from './InfoCardsContainer.types';
import SWUtilityCard from '../../Elements/SWUtilityCard/SWUtilityCard';
import { SimpleGrid } from '@uk-source-web/simple-grid';
import { InfoCardsWrapper, Spacer } from './InfoCardsContainer.styles';

const InfoCardsContainer = ({ infoCards, title, topText, topTextSize, topTextWeight, topTextGap }: InfoCardsProps) => {
  return (
    <InfoCardsWrapper>
      {topText && (
        <Heading level={topTextSize || 3} weight={topTextWeight || 3}>
          {topText}
        </Heading>
      )}
      {topTextGap && <Spacer gapHeight={topTextGap} />}
      {title && (
        <Heading level={3} weight={3}>
          {title}
        </Heading>
      )}
      <SimpleGrid
        layout={{ sm: [12], md: [4, 4], lg: [4, 4] }}
        spacing={5}
        verticalAlign={'stretch'}
        justify={'center'}
        id="grid-items"
      >
        {infoCards.map(card => (
          <SWUtilityCard {...card} />
        ))}
      </SimpleGrid>
    </InfoCardsWrapper>
  );
};

export default InfoCardsContainer;
